import {
    Box,
    Button,
    CloseIcon,
    Dialog,
    DownloadIcon,
    Flex,
    Loader,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";

import {
    Organization24Regular,
    Notebook24Regular,
} from "@fluentui/react-icons";
import CustomBreadCrumb from "../../components/breadcrumb";
import AccordionList from "./components/AccordionList";
import { initialStateExport, NAV_LIST, TABS_ANNUAIRE } from "./constant";
import { DEVICE } from "../../constants/responsive";
import ListUsers from "./components/ListUsers";
import { _formatJsonAnnuaire, _formatJsonUsers } from "./utils";
import Organigram from "./components/Organigram";
import { Container, ContainerFluid } from "../../common/styles";
import SubHeader from "../../components/breadcrumb/SubHeader";
import Searchbar from "./components/Searchbar";
import EmployeeExporterRegister from "./components/EmployeeExporterRegister";
import withAuth from "../../HOC/withAuth";
import useAnnuaire from "./hooks/useAnnuaire";
import { useSearchParams } from "react-router-dom";

const Annuaire = () => {
    const [searchParams] = useSearchParams();
    const {
        t,
        export: {
            openDownloadDialog,
            checkboxes,
            viewFormer,
            isDownloadingFile,
            setViewFormer,
            onConfirmExportRegister,
            setOpenDownloadDialog,
            setCheckboxes,
        },
        annuaire: {
            annuaire,
            panels,
            isLoading,
            TabView,
            query,
            setTabView,
            onChange,
        },
        permissions,
    } = useAnnuaire();

    return (
        <Box
            styles={{
                minHeight: "100vh",
                backgroundColor: "#F5F5F5",
            }}
        >
            {/* breadcrumb */}
            <CustomBreadCrumb
                navList={NAV_LIST}
                actions={
                    permissions.can_export_personals_register &&
                    TabView === TABS_ANNUAIRE.ANNUAIRE && (
                        <Dialog
                            open={openDownloadDialog}
                            onOpen={() => setOpenDownloadDialog(true)}
                            onCancel={() => {
                                setOpenDownloadDialog(false);
                                setCheckboxes(initialStateExport);
                            }}
                            onConfirm={onConfirmExportRegister}
                            confirmButton={{
                                content: "Confirmer",
                                loading: isDownloadingFile,
                                flat: true,
                            }}
                            cancelButton={{ content: "Annuler", flat: true }}
                            content={
                                <EmployeeExporterRegister
                                    checkboxes={checkboxes}
                                    setCheckboxes={setCheckboxes}
                                    viewFormer={viewFormer}
                                    setViewFormer={setViewFormer}
                                />
                            }
                            header="Exporter le registre du personnel"
                            headerAction={{
                                icon: <CloseIcon />,
                                title: "Close",
                                onClick: () => {
                                    setOpenDownloadDialog(false);
                                    setCheckboxes(initialStateExport);
                                },
                            }}
                            trigger={
                                <Button
                                    iconPosition="after"
                                    icon={<DownloadIcon />}
                                    inverted
                                    content="Exporter le registre du personnel"
                                />
                            }
                        />
                    )
                }
            />
            <SubHeader
                menu={[
                    {
                        content: t("common.sub_header.annuaire"),
                        icon: <Notebook24Regular />,
                        value: TABS_ANNUAIRE.ANNUAIRE,
                    },
                    {
                        content: t("common.sub_header.organigram"),
                        icon: <Organization24Regular />,
                        value: TABS_ANNUAIRE.ORGANIGRAMME,
                    },
                ]}
                setTabView={setTabView}
                TabView={TabView}
            />
            {/* searchbar */}

            {TabView === TABS_ANNUAIRE.ANNUAIRE && (
                <Searchbar onChange={onChange} />
            )}

            <ContainerFluid column styles={{ position: "relative" }}>
                <Container column>
                    {TabView === TABS_ANNUAIRE.ANNUAIRE ? (
                        <Wrapper column>
                            {/* table annuaire */}
                            <FlexStyle>
                                <Column>
                                    <Text>Nom</Text>
                                </Column>
                                <Column>
                                    <Text>Poste</Text>
                                </Column>
                                <Column hideonmobile={"true"}>
                                    <Text>Manager</Text>
                                </Column>
                                <Column hideonmobile={"true"}>
                                    <Text>Agence</Text>
                                </Column>
                                <Column hideonmobile={"true"}>
                                    <Text>N° professionnel</Text>
                                </Column>
                                <Column className="last">
                                    <Text></Text>
                                </Column>
                            </FlexStyle>
                            {/* accordion */}
                            {isLoading && (
                                <Loader label={"Chargement des données"} />
                            )}
                            {/* liste utilisateur groupés par département */}
                            {annuaire?.users?.length > 0 && (
                                <ListUsers
                                    users={_formatJsonUsers(annuaire.users)}
                                    isSearchingUser={searchParams.get("q")}
                                />
                            )}
                            {/* recherche par départements */}
                            {!isLoading && (
                                <AccordionList panels={panels} query={query} />
                            )}
                        </Wrapper>
                    ) : (
                        <Organigram />
                    )}
                </Container>
            </ContainerFluid>
        </Box>
    );
};

export default withAuth(Annuaire);

const Wrapper = styled(Flex)`
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    padding: 0px 0px;
    /* margin-top: 64px; */
`;

const TabStyle = styled.div`
    padding-inline: 20px;
`;

const FlexStyle = styled(Flex)`
    background-color: #3d3e78;
    color: white;
    border-radius: 4px 4px 0px 0px;
    padding-inline: 16px;
`;

const Column = styled.div`
    flex: 1;
    padding: 8px 10px;
    &.last {
        max-width: 100px;
    }
    @media ${DEVICE.mobileS} {
        display: ${({ hideonmobile }) =>
            hideonmobile === "true" ? "none" : "inherit"};
    }
    @media ${DEVICE.mobileL} {
        display: ${({ hideonmobile }) =>
            hideonmobile === "true" ? "none" : "inherit"};
    }
    @media ${DEVICE.mobileM} {
        display: ${({ hideonmobile }) =>
            hideonmobile === "true" ? "none" : "inherit"};
    }
    @media ${DEVICE.laptop} {
        display: flex;
    }
`;
